import type { MouseEvent } from 'react';
import { type UserSessionProviderContextProps } from '@libs/common-next';
import { requestExTokenVelocity } from './handleExchangeToken';

export async function handleServiceClick({
    authType,
    event,
    link,
}: {
    authType?: UserSessionProviderContextProps['isAuthenticated'];
    event: MouseEvent;
    link?: string;
}) {
    if (!link) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();

    const isServicesLink = link?.includes('https://services');
    if (!authType || !isServicesLink) {
        window.location.assign(link.toString());
        return;
    }

    const url = new URL(link);
    const response = authType === 'velocity' ? await requestExTokenVelocity() : null;

    if (response && 'exchangeToken' in response && response.exchangeToken) {
        url.searchParams.set('extok', response.exchangeToken);
    }

    window.location.assign(url.toString());
}
